import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Styled Components
const TestimonialsSection = styled.section`
  padding: 60px 20px;
  background-color: white;
  text-align: center;
`;

const Title = styled.h2`
  margin-bottom: 30px;
  font-size: 2rem;
  color: black;
`;

const TestimonialCard = styled.div`
  background-color: white; /* White background for each testimonial */
  color: black; /* Black text inside testimonial */
  border-radius: 10px;
  padding: 20px;
  margin: 10px;
  max-width: 600px;
  text-align: center;
  margin: 0 auto;
  position: relative;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Slight shadow for depth */
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 8px 16px rgb(88, 199, 192);
    filter: brightness(1.1);
  }
`;

const TestimonialText = styled.p`
  font-size: 1.2rem;
  margin-bottom: 20px;
  font-style: italic;
`;

const Author = styled.p`
  margin-top: 10px;
  font-size: 1rem;
  font-weight: bold;
  color: gray;
`;

// Testimonials Component
const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      text: "Hyperlocal delivery has become a breeze in the trends of q-commerce with precise stock placement. We’re delivering faster than ever, and customers love it!",
      author: "Excel, E-commerce Logistics Manager",
    },
  ];

  // Slider settings with conditional infinite looping
  const settings = {
    dots: testimonials.length > 1, // Show dots only if more than one testimonial
    infinite: testimonials.length > 1, // Infinite loop only if more than one testimonial
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: testimonials.length > 1, // Enable autoplay only if more than one testimonial
    autoplaySpeed: 3000,
    arrows: testimonials.length > 1, // Show arrows only if more than one testimonial
  };

  return (
    <TestimonialsSection>
      <Title>Customer Testimonials</Title>
      {testimonials.length > 1 ? (
        <Slider {...settings}>
          {testimonials.map((testimonial) => (
            <TestimonialCard key={testimonial.id}>
              <TestimonialText>"{testimonial.text}"</TestimonialText>
              <Author>— {testimonial.author}</Author>
            </TestimonialCard>
          ))}
        </Slider>
      ) : (
        testimonials.map((testimonial) => (
          <TestimonialCard key={testimonial.id}>
            <TestimonialText>"{testimonial.text}"</TestimonialText>
            <Author>— {testimonial.author}</Author>
          </TestimonialCard>
        ))
      )}
    </TestimonialsSection>
  );
};

export default Testimonials;
